export const selectFilterOption = (input, option) => {
  if (option.children instanceof Array) {
    return option.children.join('').toLowerCase().indexOf(input.toLowerCase()) >= 0;
  } else {
    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
};
